export default {
  // 语言
  language: {
    name: '中文'
  },
  public: {
    email: 'inquiry@governance-solutions.com'
  }

}